import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import CategoriesPage from '../modules/apps/categories-management/CategoriesPage'
import MeetingsPage from '../modules/apps/meetings-management/MeetingsPage'
import VidoesPage from '../modules/apps/videos-management/Page'
import ChildrensPage from '../modules/apps/childrens-management/Page'
import AuthorsPage from '../modules/apps/guardians-management/Page'
import AssessmentsPage from '../modules/apps/assessments-management/AssessmentsPage'
import NewsPage from '../modules/apps/news-management/NewsPage'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const CoursesPage = lazy(() => import('../pages/course-management/CoursesPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        {/* Lazy Modules */}
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='course-management/*'
          element={
            <SuspensedView>
              <CoursesPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/categories-management/*'
          element={
            <SuspensedView>
              <CategoriesPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/meetings-management/*'
          element={
            <SuspensedView>
              <MeetingsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/videos-management/*'
          element={
            <SuspensedView>
              <VidoesPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/childrens-management/*'
          element={
            <SuspensedView>
              <ChildrensPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/guardians-management/*'
          element={
            <SuspensedView>
              <AuthorsPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/news-management/*'
          element={
            <SuspensedView>
              <NewsPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/assessments-management/*'
          element={
            <SuspensedView>
              <AssessmentsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
